<script setup>
import { computed } from "vue";
import { refreshState } from "@/composables/useAutoRefresh";

const countdownDisplay = computed(() => {
  const m = Math.floor(refreshState.remainingSeconds / 60);
  const s = refreshState.remainingSeconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
});
</script>

<template>
  <div class="row gx-0 h-100">
    <AppSidebar />

    <main
      class="main col-sm-12 col-md-9 col-lg-10 offset-lg-2 offset-md-3 px-3 px-md-4 px-lg-5 h-100"
    >
      <div class="page-title">
        <span v-if="refreshState.active" class="auto-refresh-badge">
          <span class="material-icons-round" style="font-size: 14px; vertical-align: middle;">autorenew</span>
          自動更新 {{ countdownDisplay }}
        </span>
        <h5 class="label"><span>風電鳥類監測系統</span></h5>
      </div>

      <RouterView />
    </main>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/utils/breakpoint";

.page-title {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  @include breakpoint(lg) {
    margin-bottom: -1rem;
  }

  .auto-refresh-badge {
    font-size: 0.75rem;
    padding: 0.25rem 0.625rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #f8fafc;
    color: #64748b;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
    margin-right: 0.75rem;
  }

  .label {
    margin-left: auto;
    margin-right: -1rem;
    margin-bottom: 0;
    padding: 0.75rem 1.5rem 0.75rem 6rem;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    @include breakpoint(md) {
      margin-right: -1.5rem;
    }
    @include breakpoint(lg) {
      margin-right: -3rem;
    }
    span {
      display: inline-block;
      border-right: 1px solid #efe7dc;
      padding-right: 1.25rem;
    }
  }
}
</style>
